import Vue from 'vue'
import vueDebounce from 'vue-debounce'

// Setting a different event to listen to
Vue.use(vueDebounce, {
  listenTo: 'input',
})
